export default __webpack_public_path__ + "351191cf6989ae00ef85a61419f0f7a6.png";